var _symbol, _symbol2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSprite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 0,
    height: 0,
    className: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 35",
    id: "fb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.8 23.5v-9.1c0-.4-.1-.5-.5-.5H.4c-.3 0-.4-.1-.4-.4V9.8c0-.3.1-.3.4-.3h2.8c.4 0 .4-.1.4-.5-.2-1.6-.1-3.2.6-4.7 1-2.1 2.7-3.1 4.9-3.5 1.8-.4 3.6-.3 5.4-.1.3 0 .3.1.3.4v4.3c0 .3-.1.4-.4.3-.7-.1-1.3-.1-2 0-1.5.3-2.3 1.4-2.1 3.1.1.8-.1.7.8.7h3.4c.3 0 .4.1.4.4v3.6c0 .3-.1.4-.4.4H11c-.4 0-.5.1-.5.5-.2 4.7-.1 9.4-.1 14.2v4.1c0 .3-.1.4-.4.4H4.1c-.3 0-.4-.1-.4-.4.1-3.2.1-6.2.1-9.2z",
    fill: "#fff"
  }))), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 22",
    id: "vk"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 2.3v-.5c.2-.4.5-.5.9-.5 1.5 0 3.1-.1 4.6 0 .6 0 1 .3 1.3.9.1.3.2.6.3.8.6 1.4 1.3 2.8 1.9 4.2.4.9.9 1.7 1.5 2.3.2.2.5.4.8.6.3.1.6 0 .7-.3.3-.5.3-1.1.4-1.6.2-1.5.2-2.9 0-4.4-.1-1.1-.6-1.8-1.7-2-.2 0-.2-.2-.1-.4.4-.5.9-.8 1.4-.9 1.4-.2 2.7-.2 4.1-.1.4 0 .8.1 1.3.2.6.1 1 .4 1.1 1.1.1.4.1.8.1 1.2 0 1.7-.1 3.4-.1 5.1 0 .5.1 1 .2 1.5.2.6.7.8 1.1.5l.9-.9c1-1.3 1.8-2.8 2.5-4.3.5-.9.8-1.9 1.2-2.8.2-.5.5-.7 1-.7h4c.5 0 1-.1 1.4 0 .5 0 1 0 1.3.7v.5c-.1.4-.3.8-.4 1.2-.6 1.3-1.4 2.5-2.2 3.7-.8 1.1-1.5 2.3-2.3 3.4-.5.7-.4 1.3.1 2 .1.2.3.4.5.6.8.9 1.7 1.8 2.5 2.8.8.9 1.6 1.9 1.8 3.2v.2c-.2.6-.6.9-1.1.9-.7 0-1.4 0-2.2.1-.9 0-1.8.1-2.7.1-1 0-1.8-.5-2.4-1.2l-1.8-2.1c-.4-.5-.8-1-1.3-1.2-.3-.1-.5-.1-.8.1-.4.4-.7.9-.8 1.4-.1.6-.1 1.2-.2 1.7-.1.7-.4 1.2-1 1.2-.7.1-1.4 0-2.1 0-1.7 0-3.3-.5-4.8-1.5-1-.7-2-1.4-2.9-2.4-1.1-1.2-1.9-2.5-2.8-3.9-.9-1.5-1.6-2.8-2.3-4.1-.7-1.2-1.2-2.5-1.8-3.8C.7 4 .4 3.2 0 2.3z",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSprite);
export default __webpack_public_path__ + "static/media/sprite.ddd246071c2e72462c002e58c1900689.svg";
export { ForwardRef as ReactComponent };